/** @jsx jsx */

import { Fragment as _, useContext, useEffect } from 'react';
import { css as _css } from 'emotion';
import { jsx } from '@emotion/core';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext } from './interactionContext';

import { Box } from 'theme-ui';
import { useSelector } from 'react-redux';
import { contentCard_default } from 'factories/interactions/contentcard';

const Text = props => {
  const { sx = {}, children } = props;

  return (
    <Box className="text" sx={sx}>
      {children}
    </Box>
  );
};

const ButtonWrapper = ({ children }) => {
  // return children;

  return (
    <Box
      className="btn"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        margin: '15px 0 20px 0',
        padding: '0 10px',

        '> div': {
          width: '100%',
          button: {
            maxWidth: '100%',
          },
        },
        //
      }}
    >
      {children}
    </Box>
  );
};

const ContentCard = ({ children, ...props }) => {
  //

  let [media, text, btn] = children;

  const context = useContext(interactionContext) as any;

  const { id } = props as any;
  const block = getBlockById(id);

  // get the props directly off the block so updates happen
  const { selected, _props } = useSelector((state: any) => {
    return {
      selected: id === state.focusedNodeId,
      _props: block.props,
    };
  });

  const {
    contentCardBackgroundColor,
    contentCardPanelTextColor,
    contentCardContentTextColor,
    width,
    height,
    borderRadius,
    outline = false,
    borderColor,
    imagePosition,
    includeText,
    includeButton = true,
    includeShadow,
    gridCell,
    className,
    uniformHeight = false,
  } = {
    ...(context.props as any),
    ...{
      //
      ..._props,
      ...(window.dev && window.dev() && selected && _props),
    },
  } as any;

  console.log(media.props.child, { imagePosition, includeText, includeButton });

  let mediaPadding: string | number = 0;

  if (media.props.child === 0) {
    // if (window.dev && window.dev()) {
    //   mediaPadding = '10px';
    // } else {
    //   mediaPadding = '20px';
    // }
    mediaPadding = window.dev && window.dev() ? '10px' : '20px 20px 0 20px';
  }

  const textMargin = window.dev && window.dev() ? '10px' : '20px';

  return (
    <Box
      id={`card_${id}`}
      className={'card' || className}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // ...(uniformHeight && {
        //   height: '100%',
        // }),
        width: '100%',
        background: contentCardBackgroundColor,
        borderRadius,
        ...(includeShadow && {
          boxShadow: '0px 0px 10px rgba(13, 16, 40, 0.15)',
        }),

        // border: `1px solid ${outline ? borderColor : 'transparent'}`,

        ...(outline && {
          border: `1px solid ${borderColor}`,
        }),
        overflow: 'hidden',

        div: {
          color: contentCardContentTextColor,
        },
      }}
    >
      {imagePosition === 'top' && (
        <_>
          <span>
            <Box
              className="media"
              sx={{
                width: '100%',
                padding: mediaPadding,
              }}
            >
              {media}
            </Box>
            {includeText && (
              <Text
                sx={{
                  margin: textMargin,
                }}
              >
                {text}
              </Text>
            )}
          </span>
          {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        </_>
      )}

      {imagePosition === 'right' && (
        <Box>
          <Box sx={{ display: 'flex' }}>
            {includeText && (
              <Text sx={{ flex: 1, margin: textMargin }}>{text}</Text>
            )}
            <Box
              className="media"
              sx={{
                flex: 1,
                padding: mediaPadding,
              }}
            >
              {media}
            </Box>
          </Box>
          {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        </Box>
      )}

      {imagePosition === 'bottom' && (
        // <Box sx={{}}>
        //   {includeText && <Text sx={{ margin: '10px' }}>{text}</Text>}
        //   <Box
        //     className="media"
        //     sx={{
        //       width: '100%',
        //     }}
        //   >
        //     {media}
        //   </Box>

        //   {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        // </Box>

        <_>
          <span>
            {includeText && <Text sx={{ margin: textMargin }}>{text}</Text>}
            <Box
              className="media"
              sx={{
                width: '100%',
                padding: mediaPadding,
              }}
            >
              {media}
            </Box>
          </span>
          {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        </_>
      )}

      {imagePosition === 'left' && (
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box
              className="media"
              sx={{
                flex: 1,
                padding: mediaPadding,
              }}
            >
              {media}
            </Box>
            {includeText && (
              <Text sx={{ flex: 1, margin: textMargin }}>{text}</Text>
            )}
          </Box>
          {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        </Box>
      )}

      {imagePosition === 'none' && (
        <Box>
          <Text sx={{ margin: `20px ${textMargin}` }}>{text}</Text>
          {includeButton && <ButtonWrapper>{btn}</ButtonWrapper>}
        </Box>
      )}
    </Box>
  );
};

export default ContentCard;
